//
//
//
//
//
//
//
//
//
//

export default {
  name: 'app',
  created() {
  },
  computed: {},

  components: {},
  data() {
    return {};
  },
  methods: {}
};



// WEBPACK FOOTER //
// ./src/App.vue